declare var Razorpay: any;

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class RazorpayService {


  loadRazorpay(): Promise<boolean> {
    return new Promise((resolve, reject) => {

      if (typeof Razorpay !== 'undefined') {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;

      script.onload = () => resolve(true);
      script.onerror = () => reject(false);

      document.body.appendChild(script);
    });
  }

  constructor() { }
}
